<template>
	<div>
		<section
			id="page-title"
			class="page-title-parallax"
			style="background-image: url('/assets/img/tuitionandfees.jpg'); padding: 120px 0"
			data-stellar-background-ratio="0.3"
		>
			<div class="container clearfix">
				<h1 data-animate="fadeInUp">Tuition &amp; Fees</h1>
				<span data-animate="fadeInUp" data-delay="300"><b>FREE</b> trial class</span>
			</div>
		</section>
		<section id="content">
			<div class="content-wrap">
				<div class="container clearfix">
					<div class="pricing pricing-5 bottommargin clearfix">
						<div class="pricing-box pricing-minimal">
							<div class="pricing-title">
								<h3>first class</h3>
								<span>BEGINNERS</span>
							</div>
							<div class="pricing-price">
								<span class="price-unit">&dollar;</span>0<span class="price-tenure">/mo</span>
							</div>
							<div class="pricing-action">
								<router-link :to="{ name: 'Contact' }" class="btn btn-danger btn-block">Get Started</router-link>
							</div>
						</div>

						<div class="pricing-box pricing-minimal">
							<div class="pricing-title">
								<h3>1 class</h3>
								<span>per week</span>
							</div>
							<div class="pricing-price">
								<span class="price-unit">&dollar;</span>90<span class="price-tenure">/mo</span>
							</div>
							<div class="pricing-action">
								<router-link :to="{ name: 'Contact' }" class="btn btn-danger btn-block">Get Started</router-link>
							</div>
						</div>

						<div class="pricing-box pricing-minimal best-price">
							<div class="pricing-title">
								<h3>2 classes</h3>
								<span>per week</span>
							</div>
							<div class="pricing-price">
								<span class="price-unit">&dollar;</span>140<span class="price-tenure">/mo</span>
							</div>
							<div class="pricing-action">
								<router-link :to="{ name: 'Contact' }" class="btn btn-danger btn-block">Get Started</router-link>
							</div>
						</div>

						<div class="pricing-box pricing-minimal">
							<div class="pricing-title">
								<h3>3 classes</h3>
								<span>per week</span>
							</div>
							<div class="pricing-price">
								<span class="price-unit">&dollar;</span>170<span class="price-tenure">/mo</span>
							</div>
							<div class="pricing-action">
								<router-link :to="{ name: 'Contact' }" class="btn btn-danger btn-block">Get Started</router-link>
							</div>
						</div>

						<div class="pricing-box pricing-minimal">
							<div class="pricing-title">
								<h3>4 classes</h3>
								<span>per week</span>
							</div>
							<div class="pricing-price">
								<span class="price-unit">&dollar;</span>190<span class="price-tenure">/mo</span>
							</div>
							<div class="pricing-action">
								<router-link :to="{ name: 'Contact' }" class="btn btn-danger btn-block">Get Started</router-link>
							</div>
						</div>
					</div>
					<div class="pricing bottommargin clearfix">
						<div class="col-sm-4 pricing-box pricing-minimal">
							<div class="pricing-title">
								<h3>5 classes</h3>
								<span>per week</span>
							</div>
							<div class="pricing-price">
								<span class="price-unit">&dollar;</span>210<span class="price-tenure">/mo</span>
							</div>
							<div class="pricing-action">
								<router-link :to="{ name: 'Contact' }" class="btn btn-danger btn-block">Get Started</router-link>
							</div>
						</div>
						<div class="col-sm-4 pricing-box pricing-minimal">
							<div class="pricing-title">
								<h3>6 classes</h3>
								<span>per week</span>
							</div>
							<div class="pricing-price">
								<span class="price-unit">&dollar;</span>230<span class="price-tenure">/mo</span>
							</div>
							<div class="pricing-action">
								<router-link :to="{ name: 'Contact' }" class="btn btn-danger btn-block">Get Started</router-link>
							</div>
						</div>						
					</div>
					<div class="col-lg-12 center">
						<h2>Payment</h2>
						<h4>
							Payment is due in full on the first of the month. After the 7th, you will be charged a $30.00 late fee.
							<br />
							We accept checks and cash. Credit cards are accepted with a 3% convenience fee.<br />
							Infinity Dance Studio will not issue refunds.
						</h4>

						<h2>Registration Fee</h2>
						<h4>
							Registration fee of $60.00 is once a year payment. This is a non-refundable fee. If the student retires
							from dancing for a full month, registration will be required when returning. <br />
							Additional siblings: $30/each
						</h4>

						<h2>Make-Up Classes</h2>
						<h4>
							In case of missed class due to emergency, it may be made up within 30 days from the day of absence. No
							credits/refunds will be issued for any missed classes.
						</h4>
					</div>
				</div>
			</div>
			<!-- #content end -->
		</section>
	</div>
</template>
<script>
export default {
	name: 'tuitionandfees',
	components: {},
}
</script>
